if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (
            nextElementToFocus &&
            !nextElementToFocus.classList.contains('hidden') &&
            nextElementToFocus.querySelector('input')
          ) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const button = this.querySelector('button');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        const isExpanded = this.querySelector('.label-show-less.label-text:not(.hidden)') !== null;
        if (button?.hasAttribute('aria-expanded')) {
          button.setAttribute('aria-expanded', isExpanded);
        }
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
        // When collapsing, bring the user back to the top of the module so they
        // don't have to scroll all the way up after the list shrinks.
        if (!isExpanded) {
          parentDisplay.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    },
  );
}
